
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import store from "./store"
import { Toast, Dialog, Tab, Tabs } from "vant";
// import VueClipBoard from 'vue-clipboard2'
import "vant/lib/index.css";
// import wx from 'weixin-js-sdk';

Vue.use(Toast)
   .use(Dialog)
   .use(Tab)
   .use(Tabs);
// Vue.use(wx);
Vue.config.productionTip = false;
// window.wx = wx;
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  
  next()
})

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
